var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb user-nav"},[_c('li',{staticClass:"breadcrumb-item"},[_vm._v(_vm._s(_vm.name))]),_vm._l((_vm.users),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb-item"},[(_vm.users.length - 1 != index)?_c('router-link',{attrs:{"to":{
        name: _vm.$route.name,
        params: { userId: item.id },
        query: _vm.$route.query,
      }}},[_vm._v(_vm._s(item.username))]):_vm._e(),(_vm.users.length - 1 == index)?_c('span',[_vm._v(_vm._s(item.username))]):_vm._e()],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }